export const SESSION_EXPIRED_FAULT_CODE = '109';

export default {
  ACCESS_DENIED: '117',
  ACCESS_DENIED_INSUFFICIENT_ACCESS: '117-11705',
  ADDRESS_NOT_FOUND: '1100',
  CONNECTION_FAULT: '3',
  DEESCALATION_DATE_FAILURE: '1233',
  FULL_SUITE_ADDRESS_VALIDATION_FAILED: '1193',
  IDENTITY_PROVIDER_NOT_FOUND: '129',
  INVALID_REQUEST: '27',
  LOGIN_ALREADY_EXISTS: '113',
  LOGIN_NOT_VALID: '123',
  MAINTENANCE_MODE: '22',
  NON_UNIQUE_PASSWORD_VIOLATION: '116',
  PASSWORD_LOCKED: '121',
  PASSWORD_STRENGTH_VIOLATION: '115',
  REMOVE_ADDRESS_FAILURE: '1124',
  SERVICE_UNAVAILABLE: '503',
  SESSION_EXPIRED: SESSION_EXPIRED_FAULT_CODE,
  SUBSCRIBER_LIMIT_REACHED: '1261',
  TECHNICAL_ISSUE: '23',
  UNKNOWN: '0',
  UPSTREAM_SERVICE_TIMEOUT: '35',
  USER_NOT_FOUND: '111'
};
